import { z } from "zod";

/**
 * ObraInformacoesSchema
 */

export const ObraInformacoesSchema = z.object({
  idFuncionario: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  data: z.coerce.date({ required_error: 'Este campo deve ser preenchido!' }),
  descInformacoes: z.string({ required_error: 'Este campo deve ser preenchido!' }).nonempty('Este campo deve ser preenchido!'),
});

/**
 * ObraInformacoesForm
 */

export type ObraInformacoesForm = z.infer<typeof ObraInformacoesSchema>;